import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone } from 'lucide-react';

export const Footer = ({ t }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-orange-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="relative h-16 w-16 flex items-center justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_lodge-website/artifacts/t81s6amh_1000015829.png"
                  alt="Outaouais Big Game Logo"
                  className="h-16 w-16 object-contain"
                />
              </div>
              <div className="ml-3">
                <span className="text-orange-500 font-bold text-xl block">
                  Outaouais Big Game
                </span>
                <span className="text-gray-500 text-xs">Permis de pourvoirie 07-919</span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              {t.footer.description}
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500 transition-colors duration-200"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500 transition-colors duration-200"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500 transition-colors duration-200"
              >
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">
              {t.footer.quickLinks}
            </h3>
            <ul className="space-y-2">
              {Object.keys(t.nav).map((key) => (
                <li key={key}>
                  <button
                    onClick={() => scrollToSection(key)}
                    className="text-gray-400 hover:text-orange-500 transition-colors duration-200"
                  >
                    {t.nav[key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center">
                <Phone className="h-5 w-5 text-orange-500 mr-3" />
                <span>(819) 431-2712</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-orange-500 mr-3" />
                <span>hdnighttrain@outlook.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-orange-500/20 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Outaouais Big Game Hunting. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
